import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import QuestSix from "../../components/quote-components/quoteQuestions/QuestSix";

const QuestionSix = () => {
  const { closeNavbarMenu } = useNavContext();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main onMouseOver={closeNavbarMenu}>
      <QuestSix />
    </main>
  );
};

export default QuestionSix;
